import * as SegmentGroup from '@/components/ui/segment-group'
import { useService } from 'solid-services'
import { useSetups } from './state'

export const Filter = () => {
  const { mode, setMode } = useService(useSetups)()

  return (
    <SegmentGroup.Root
      variant='outline'
      value={mode()}
      onValueChange={(details) => setMode(details.value as any)}
      size="xs"
      orientation="horizontal"
    >
      <SegmentGroup.Indicator />

      <SegmentGroup.Item value="latest">
        <SegmentGroup.ItemText textStyle='xs'>All</SegmentGroup.ItemText>
        <SegmentGroup.ItemControl position='absolute' />
        <SegmentGroup.ItemHiddenInput />
      </SegmentGroup.Item>

      <SegmentGroup.Item value="taken">
        <SegmentGroup.ItemText textStyle='xs'>Subscribed</SegmentGroup.ItemText>
        <SegmentGroup.ItemControl position='absolute' />
        <SegmentGroup.ItemHiddenInput />
      </SegmentGroup.Item>
    </SegmentGroup.Root>
  )
}
